'use client';
import { use } from 'react';
import Link from 'next/link';
import { useAboutDataContext } from '@/providers/AboutDataProvider';
import { NoResults } from '@/components/features/NoResults/NoResults';
import { PhoneLink } from '@/components/ui/PhoneLink/PhoneLink';
import { SvgStar } from '@/components/icons';
import { MedicalTestResponse } from '@/api/analyses/analyses.types';
import { ResponseBasis } from '@/api/api.types';
import s from './MostAppropriate.module.scss';

interface Props {
  analyses: Promise<ResponseBasis<MedicalTestResponse>>;
}

export const MostAppropriate = ({ analyses }: Props) => {
  const { aboutData } = useAboutDataContext();
  const allAnalyses = use(analyses);

  return (
    <div className={s.mostAppropriate}>
      {allAnalyses.items.length > 0 ? (
        <>
          <h2>Наиболее подходящие анализы</h2>
          <ul className={s.mostAppropriate__list}>
            {allAnalyses.items.map((item) => {
              return (
                <li key={item.id} className={s.mostAppropriate__item}>
                  <Link href={`/analyses/${item.id}`} className={s.mostAppropriate__link}>
                    {item.analysis_title}
                    <div className={s.mostAppropriate__hoverIcon}>
                      <SvgStar />
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </>
      ) : (
        <NoResults>
          <p>
            Извините, но запрашиваемые вами анализы не найдены. <br />
            Пожалуйста, измените условия поиска или позвоните нам по телефону <PhoneLink phone={aboutData?.main_phone} codeIsFour/>.
          </p>
        </NoResults>
      )}
    </div>
  );
};